import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history", // 去掉地址栏的/#号
  routes: [
    {
      // 首页
      path: "/",
      name: "homePage",
      component: resolve => require(["@/pages/homePage/homePage"], resolve)
    },
    {
      // 智能本列表
      path: "/smartPenList",
      name: "smartPenList",
      component: resolve =>
        require(["@/pages/smartPenManagement/smartPenList"], resolve)
    },
    {
      // 智能本详情
      path: "/detailspage",
      name: "detailspage",
      component: resolve =>
        require(["@/pages/smartPenManagement/detailspage"], resolve)
    },
    {
      // 反馈列表
      path: "/feedbackList",
      name: "feedbackList",
      component: resolve => require(["@/pages/feedback/feedbackList"], resolve)
    },
    ,
    {
      //离线数据查看
      path: "/Offlinedata",
      name: "Offlinedata",
      component: resolve =>
        require(["@/pages/Offlinedata/Offlinedata"], resolve)
    },
    {
      //离线数据查看详情
      path: "/OfflinedataDetails",
      name: "OfflinedataDetails",
      component: resolve =>
        require(["@/pages/Offlinedata/OfflinedataDetails"], resolve)
    },
    {
      //异常
      path: "/abnormal",
      name: "abnormal",
      component: resolve => require(["@/pages/abnormal/abnormal"], resolve)
    }
  ]
});

router.afterEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "硕云笔记管理平台";
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js